import { combineReducers } from 'redux';

import { authentication } from './authentication/authentication';
import { currencies } from './currencies/currencies';
import { documentsCollection } from './documentsCollection/documentsCollection';
import { docVerifyResults } from './docVerifyResults/docVerifyResults';
import { errors } from './errors/errors';
import { fees } from './fees/fees';
import { fields } from './fields';
import { items } from './items/items';
import { links } from './links/links';
import { lrs } from './lrs/lrs';
import { offers } from './offers/offers';
import { order } from './order/order';
import { payment } from './payment/payment';
import { payments } from './payments/payments';
import { payouts } from './payouts/payouts';
import { prices } from './prices/prices';
import { purchases } from './purchases/purchases';
import { recipient } from './recipient/recipient';
import { recipients } from './recipients/recipients';
import { recurringOffers } from './recurringOffers/recurringOffers';
import { recurringReceivables } from './recurringReceivables/recurringReceivables';
import { repeatPaymentOffer } from './repeatPaymentOffer/repeatPaymentOffer';
import { rewards } from './rewards/rewards';
import { sections } from './sections';
import { selected } from './selected';
import { user } from './user/user';

const entities = combineReducers({
  authentication,
  rewards,
  currencies,
  docVerifyResults,
  documentsCollection,
  errors,
  fees,
  fields,
  items,
  links,
  lrs,
  offers,
  order,
  payment,
  payments,
  payouts,
  prices,
  purchases,
  recipient,
  recipients,
  recurringOffers,
  recurringReceivables,
  repeatPaymentOffer,
  sections,
  selected,
  user,
});

export { entities };
